// import { Dropdown, Menu, Button } from "antd";

import React, { useState, useEffect } from "react";
// import {
//   DotMenuIcon,
// } from "../../assets/Icons";
import Modal from "../../components/Modal";
import NotificationModel from "./NotificationModel";
import DataTable from "../../components/DataTable";
import { useSelector } from "react-redux";

import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import { useDeleteNotificationMutation, useGetNotificationsQuery } from "../../store/services/notificationService";
import { useFetchCustomersQuery } from "../../store/services/customerService";
import DeleteConfirmationModel from "../../components/DeleteConfirmationModel";
import { Box, Button, Grid, Typography } from "@mui/material";
import { primaryButtonStyle } from "../../configs/theme";
import CustomDataTable from "../../components/DataTable";
import { Add, DescriptionOutlined } from "@mui/icons-material";
import colors from "../../styles/colors";

const Notifications = () => {
  const words = useSelector((state) => state.authReducer.words);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [deletedId, setDeletedId] = useState("");

  // const { data: notificationsList, isLoading: bookingLoading, isSuccess: success, isError: error } = useGetNotificationsQuery();
  const { data: notificationsList, isLoading } = useGetNotificationsQuery();
  const { data: users, isLoading: usersLoading, error } = useFetchCustomersQuery({ page_no: 'all' });
  const [
    deleteNotifications,
    { isLoading: deleteNotifLoading, isSuccess, isError },
  ] = useDeleteNotificationMutation();

  const columns = [
    {
      label: words["Id"],
      field: "id",
      key: "id",
    },
    {
      label: words["Title"],
      field: "title",
      key: "title",
    },
    {
      label: words["Description"],
      field: "description",
      key: "description",
    },
    // {
    //   title: words["Action"],
    //   key: "action",
    //   render: (_, record) => (
    //     <Dropdown
    //       overlay={
    //         <Menu
    //           onClick={({ key }) => {
    //             if (key == "delete") {
    //               setDeletedId(record.group_id);
    //               setOpenDeleteModal(true);
    //               return;
    //             }
    //           }}
    //         >
    //           <>
    //             <Menu.Item key="delete">{words["Delete"]}</Menu.Item>
    //           </>
    //         </Menu>
    //       }
    //       trigger={["click"]}
    //     >
    //       <Button>
    //         <div className="flex items-center justify-center cursor-pointer text-[#0025F2]">
    //           {/* <DotMenuIcon /> */}
    //         </div>
    //       </Button>
    //     </Dropdown>
    //   ),
    // },
  ];

  useEffect(() => {
    if (isSuccess) {
      toast.success("Deleted successfully");
    }
    if (isError) {
      toast.error("Something went wrong! Please try again later");
    }
  }, [isSuccess, isError]);


  return (
    <>
      <Box sx={{ padding: "16px", backgroundColor: "#F5F5F5" }}>
        <Loader open={isLoading} />
        <Grid container spacing={1} alignItems="center">
          {/* Tabs */}



          {/* Action Buttons */}
          <Grid item xs={12} sm={6} md={4} lg={4}>
            <Box sx={{ display: "flex", gap: "10px", flexDirection: "row" }}>
              <Button
                onClick={() => setOpenModal(true)}
                variant="contained"
                startIcon={<Add />}
                sx={{
                  backgroundColor: colors.primary,
                  fontSize: 12,
                  color: "white",
                  fontFamily: "PMe",
                  borderRadius: "20px",
                  padding: "8px 16px",
                  textTransform: "none",
                }}
              >
                {words["New notification"]}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Data Table */}
      <Box sx={{ paddingRight: '16px', paddingLeft: '16px', backgroundColor: colors.bg }}>
        {isLoading ? (
          <Typography></Typography>
        ) : error ? (
          <Typography>Error loading customers</Typography>
        ) : (
          <CustomDataTable
            data={notificationsList?.data || []} // Use filtered data
            columns={columns}
          // totalPages={data?.data?.last_page || 1}
          // currentPage={currentPage}
          // onPageChange={(page) => setCurrentPage(page)}

          />
        )}
      </Box>


      <NotificationModel
        onClose={() => setOpenModal(false)}
        open={openModal}
        users={users?.data ?? []}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />



      {/* <AddCustomerDialog open={open} onClose={() => setOpen(false)} /> */}
      {/* <EditCustomerDialog data={selectedCustomer} open={editModal} onClose={() => setEditModal(false)} /> */}

      {/* <Dialog open={deleteModal} onClose={() => setDeleteModal(false)}>
        <DialogTitle
          sx={{ fontFamily: 'PSBo' }}
        >Are you sure?</DialogTitle>
        <DialogContent>
          <Typography
            sx={{ fontFamily: 'PRe' }}
          >
            Are you sure you want to delete this customer? Deleting a customer will remove all their data.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDeleteModal(false)}
            variant="outlined"
            sx={{
              borderRadius: "20px",
              fontSize: 12,
              textTransform: "none",
              fontFamily: "PMe",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteCustomer}
            variant="contained"
            disabled={isDeleting}

            sx={{
              backgroundColor: colors.danger,
              fontSize: 12,
              color: "white",
              borderRadius: "20px",
              padding: "8px 16px",
              textTransform: "none",
              fontFamily: "PMe",
            }}
          >
            {isDeleting ? "Deleting..." : "Delete"}
          </Button>
        </DialogActions>
      </Dialog> */}



    </>

  )
  return (
    <>
      <Loader open={deleteNotifLoading || isLoading || usersLoading} />

      <div className="notification-page min-h-screen flex">
        <div className="wrap wrapWidth flex flex-col">
          <div className="flex flex-col gap-5 mt-6">

            <Button
              sx={primaryButtonStyle}
              // className="!flex items-center button bg-themeColor rounded-full gap-2 !py-[2px]"
              onClick={(e) => setOpenModal(true)}
            // style={{ zIndex: 1 }}
            >
              <div className="flex items-center justify-center text-white font-normal text-2xl">
                +
              </div>
              <label className="text-white cursor-pointer">
                {words["Add"]}
              </label>
            </Button>


            <div style={{ marginTop: -50 }}>
              <DataTable
                searchContainerStyle={{ width: "40%" }}
                data={notificationsList?.data ?? []}
                columns={columns}
              />
            </div>
          </div>
        </div>
        <Modal open={openModal} setOpen={setOpenModal}>
          <NotificationModel
            users={users?.data ?? []}
            openModal={openModal}
            setOpenModal={setOpenModal}
          />
        </Modal>
        <Modal open={openDeleteModal} setOpen={setOpenDeleteModal}>
          <DeleteConfirmationModel
            openModal={openDeleteModal}
            setOpenModal={setOpenDeleteModal}
            onSubmit={() => deleteNotifications(deletedId)}
          />
        </Modal>
      </div>
    </>
  );
};

export default Notifications;
